import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const DropdownItem = styled(FlexRow)`
    padding: 10px 16px;
    align-items: center;
    cursor: pointer;

    &:hover {
        background: ${colorsPalettes.carbon[25]};
    }
`;

export const ItemText = styled.p`
    margin: 0;
    padding-left: 8px;
    ${setFontVariant("input2", colorsPalettes.carbon[500])}
`;

export const KeywordsDropdown = styled.div`
    width: 360px;
`;
